// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const getWorkflowResultGroupDetailsQuery: any = graphql(`
  query GetWorkflowResultGroup($id: String!) {
    workflowResultGroup(id: $id) {
      assigner {
        id
        name
      }
      audience {
        dateRange {
          after
          before
        }
        days
        id
        matchingCriteria
        name
        type
        segmentationType
        image
      }
      completedAssignments
      createdAt
      dueDate
      id
      resultCount
      results {
        id
        results {
          result
          resultType
        }
        user
      }
      settings {
        assignmentOptions {
          delay
        }
        conditionals {
          days
          id
          name
          type
        }
        daysToComplete
        dueFromHired
        escalateBuddy
        escalateManager
        escalationContacts {
          id
          fullName
          image
        }
        name
        nonReminderMessages {
          ...NotificationMessageDetailsFragment
        }
        objectNumber
        objectType
        overdueMessages {
          cadence
          message {
            ...NotificationMessageDetailsFragment
          }
          totalMessages
        }
        partnerPermissions
        reminderMessages {
          message {
            ...NotificationMessageDetailsFragment
          }
          timeBeforeDue
        }
        requireRecompletion
        responses {
          content {
            contentType
            id
            title
          }
          type
        }
        shareOptions {
          emailBody
          emailFromEmail
          emailFromName
          emailSubject
        }
        triggerObject {
          id
          title
        }
        type
      }
      totalAssignments
      triggeredForUsers
      updatedAt
      workflow
    }
  }
`);
